import {
    createElementVNode as _$ce,
    createTextVNode as _$ct,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {XMarkdown, Switch} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'span', [
                _$ct('allowHtml: '),
                _$cc(Switch, {
                    'value': this.get('allowHtml'),
                    'ev-$change:value': this.setAllowHtml
                })
            ], 4),
            _$ce(2, 'span', [
                _$ct('allowNoticeCard: '),
                _$cc(Switch, {
                    'value': this.get('allowNoticeCard'),
                    'ev-$change:value': this.setAllowNoticeCard
                })
            ], 4)
        ], 4, 'xmarkdown-demo-html-actions'),
        _$cc(XMarkdown, {
            'content': this.get('content'),
            'allowHtml': this.get('allowHtml'),
            'sanitizeOptions': this.getSanitizeOptions()
        })
    ], 4, 'xmarkdown-demo-html');
};